<div id="page-blocker" *ngIf="showSpinner">
  <app-loading-spinner [spinnerMsg]="spinnerMsg"></app-loading-spinner>
</div>